import { entityEffectiveStatus } from "./entityEffectiveStatus";

export const nestedEntityEffectiveRangeStatus = (entity, effectiveAsOf) => {
	const status = entityEffectiveStatus(entity, effectiveAsOf);
	if(status.isEither) {
		return status;
	}

	if(!entity.Entities)
		return { isValid: false, isInGrace: false, isEither: false };

	const childStatus = entity.Entities.reduce((agg, child) => {
		const childStatus = nestedEntityEffectiveRangeStatus(child.Entity, effectiveAsOf);
		if(!childStatus.isEither)
			return agg;

		return ({
			hasValid: agg.hasValid || childStatus.isValid,
			hasGrace: agg.hasGrace || childStatus.isInGrace,
			hasEither: agg.hasEither || childStatus.isValid || childStatus.isInGrace
		});
	}, {
		hasValid: false,
		hasGrace: false, 
		hasEither: false
	});

	return { isValid: false, isInGrace: false, isEither: false, children: childStatus };
};